import React, { FC, useEffect, useState } from 'react';
import { Box, Dialog, TextField, DialogContent, DialogTitle } from '@material-ui/core';
import { BlueTickIcon, DialogCloseComponent, SearchIcon } from 'Components';
import classNames from 'classnames';
import { useLocalization } from 'Hooks';
import { turkishCharacterNormalize } from 'Utils';
import { useSelector } from 'react-redux';

import './DialogApartment.scss';
import { AccountState, storeAccount } from 'Stores/Account';
import { ApartmentItemType } from 'Services/Queries/GetApartmentList';

type DialogApartmentProps = {
  hide: () => void;
  isOpen: boolean;
  selectedValue?: string;
  setSelectedValue: Function;
};

const DialogApartment: FC<DialogApartmentProps> = ({ hide, isOpen, selectedValue, setSelectedValue }) => {
  const { web_account_search } = useLocalization();
  const [searchKey, setSearchKey] = useState<string>('');

  const lowerCaseSearchKey = searchKey.toLocaleLowerCase();

  const accountData: AccountState = useSelector(storeAccount);

  const apartments: ApartmentItemType[] | undefined = accountData?.apartmentList;

  const itemClickHandle = (apartmentItem: ApartmentItemType) => {
    setSelectedValue(apartmentItem);
    hide();
  };

  const onClose = () => {
    setSearchKey('');
    hide();
  };

  useEffect(() => {
    setSearchKey('');
  }, [hide]);

  return (
    <Dialog id="dialogApartment" onClose={onClose} scroll="paper" keepMounted={false} open={isOpen}>
      <Box position="absolute" top={8} right={8} zIndex={2}>
        <DialogCloseComponent closeFunction={hide} />
      </Box>
      <DialogTitle className="dialogApartment-search" style={{ paddingRight: 48 }}>
        <TextField
          label={web_account_search}
          variant="filled"
          value={searchKey}
          onChange={(e) => setSearchKey(e.currentTarget.value)}
          InputProps={{
            endAdornment: <SearchIcon />,
          }}
          fullWidth
        />
      </DialogTitle>

      <DialogContent>
        <div className="dialogApartment-container">
          <JobBlock
            apartmentItems={apartments}
            searchKey={searchKey}
            selectedValue={selectedValue}
            lowerCaseSearchKey={lowerCaseSearchKey}
            itemClickHandle={itemClickHandle}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

const JobBlock: FC<{
  apartmentItems: ApartmentItemType[] | undefined;
  searchKey: string;
  lowerCaseSearchKey: string;
  selectedValue?: string;
  itemClickHandle: Function;
}> = ({ apartmentItems, lowerCaseSearchKey, selectedValue, itemClickHandle }) => {
  return (
    <ul className="dialogApartment-container__list" role="listbox">
      {!!apartmentItems &&
        apartmentItems.length > 0 &&
        apartmentItems
          .filter((item: ApartmentItemType) => {
            return (
              !!item?.icKapiNo1 &&
              turkishCharacterNormalize(String(item?.icKapiNo1)).includes(turkishCharacterNormalize(lowerCaseSearchKey))
            );
          })
          .map((item: ApartmentItemType, index) => (
            <Item
              key={index}
              title={String(item.icKapiNo1)}
              isSelected={String(item.icKapiNo1).toLocaleLowerCase('tr-TR') === selectedValue}
              onClick={() => itemClickHandle(item)}
            />
          ))}
    </ul>
  );
};

const Item: FC<{
  title: string;
  onClick: Function;
  isSelected: boolean;
}> = ({ title, onClick, isSelected }) => {
  return (
    <li 
      onClick={() => onClick()} 
      role="option"
      aria-selected={isSelected}
      tabIndex={0}
      onKeyDown={(e)=>{
        if(e.key === 'Enter' || e.key === ' '){
          e.preventDefault();
          onClick();
        }
      }}
      itemID="chooseAdressApartmentBtnTest">
      <div
        className={classNames({
          'dialogApartment-container__list-item': true,
          'dialogApartment-container__list-item--selected': isSelected,
        })}
      >
        <span className="input-text">{title.toLocaleLowerCase('tr-TR')}</span>
        {isSelected && <BlueTickIcon />}
      </div>
    </li>
  );
};

export default DialogApartment;
